import { extends as _extends, objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';
import { useGaudiLocalization } from '../Provider/Provider.js';
import { useProxiedRef } from '../../utils/hooks/useProxiedRef.js';
import { setInputValueByRef } from '../../utils/input.js';
import { usePopoverState } from 'reakit';
import { format, parseFromCustomString } from '../../utils/date.js';

var _excluded = ["defaultValue", "calendar", "onBlur", "onChange", "value"];
var useDatepicker = function useDatepicker(_ref, ref) {
  var calendar = _ref.calendar,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var inputRef = useProxiedRef(ref);

  var _useGaudiLocalization = useGaudiLocalization(),
      formatting = _useGaudiLocalization.formatting;

  var _React$useState = useState(value ? format(value, formatting.date) : ''),
      internalValue = _React$useState[0],
      setInternalValue = _React$useState[1];

  var popover = usePopoverState({
    placement: 'bottom-start'
  }); // update internal value if it changed 'externally'

  useEffect(function () {
    var formattedValue = format(value, formatting.date);

    if (value !== undefined && formattedValue !== internalValue) {
      setInternalValue(formattedValue);
    }
  }, [value]); // event handlers

  var handleInputBlur = function handleInputBlur(event) {
    event.persist();
    var valueAsDate = parseFromCustomString(event.target.value);
    var formattedValue = valueAsDate ? format(valueAsDate) || '' : '';
    event.target.value = formattedValue;

    if (onChange) {
      event.detail = valueAsDate;
      onChange(event);
    } else {
      // update the internal value to use the formatted date
      setInternalValue(formattedValue);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    setInternalValue(event.target.value);
  };

  var handleCalendarClickDay = function handleCalendarClickDay(date) {
    setInputValueByRef(inputRef.current, format(date, formatting.date), 'blur');
    popover.hide();
  };

  var handleCalendarClickToday = function handleCalendarClickToday() {
    var today = new Date(); // set to midday to avoid UTC offset causing dates to be mismatched server side

    today.setHours(12);
    today.setMinutes(0);
    today.setSeconds(0);
    setInputValueByRef(inputRef.current, format(today, formatting.date), 'blur');
    popover.hide();
  };

  var inputProps = _extends({}, props, {
    autoComplete: 'off',
    onBlur: handleInputBlur,
    onChange: handleInputChange,
    ref: inputRef,
    type: 'text',
    value: internalValue
  });

  var calendarProps = _extends({}, calendar, {
    modifiers: {
      highlighted: value
    },
    month: value,
    onDayClick: handleCalendarClickDay,
    onTodayButtonClick: handleCalendarClickToday
  });

  return {
    input: inputProps,
    calendar: calendarProps,
    popover: _extends({}, popover, {
      tabIndex: -1
    })
  };
};

export { useDatepicker };
//# sourceMappingURL=useDatepicker.js.map
